<template>
    <!-- <div> -->
        <!-- <img :src="getMapUrl()" class="basemap" alt="Mapa de entrega del pedido"> -->
        <!-- <img src="https://api.mapbox.com/styles/v1/mapbox/streets-v11/static/-108.979919434,25.7938499451,14/600x100?access_token=pk.eyJ1IjoiZGFuaWVscGFyZWRlcyIsImEiOiJja3BmbHdnZW0wMDc0MnVtc3BoaG1oMXc3In0.FMqn4zJJ1vqZIhIJtkIccw" class="basemap"> -->
        <!-- <img src="https://api.mapbox.com/styles/v1/mapbox/streets-v11/static/pin-s-k+991f00(-108.979919434,25.7938499451)/-108.979919434,25.7938499451,13.5,0,0/1080x200@2x?access_token=pk.eyJ1IjoiZGFuaWVscGFyZWRlcyIsImEiOiJja3BmbHdnZW0wMDc0MnVtc3BoaG1oMXc3In0.FMqn4zJJ1vqZIhIJtkIccw" class="basemap"> -->
    <!-- </div> -->

    <div :style="heightMap">
        
        <l-map
        :zoom="zoom"
        :center="center"
        style="height: 100%"
        @update:center="centerUpdate"
        @update:zoom="zoomUpdate"
        >
            <l-tile-layer
                :url="url"
                :attribution="attribution"
            />
            <l-marker :lat-lng="withPopup">
                <l-popup>
                    <div>Destino</div>
                </l-popup>
            </l-marker>
        </l-map>
    </div>
</template>

<script>
import { latLng, Icon  } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LTooltip } from "vue2-leaflet";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default {
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        LTooltip
    },
    props: {
        latitud: {
            type    : Number,
        },
        longitud: {
            type    : Number,
        },
    },
    data() {
    return {
        zoom: 16,
        center: latLng(this.latitud, this.longitud),
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution:'<a href="https://kuroda.com/">Kuroda</a> | &copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        withPopup: latLng(this.latitud, this.longitud),
        currentZoom: 16,
        currentCenter: latLng(this.latitud, this.longitud),
    };
  },
  created() {

  },
  methods: {
    getMapUrl () {
        // let marker = "pin-s-embassy+991f00"
        // let coordenadas = this.longitud+","+this.latitud
        // let zoom = "14"
        // let imageMap = "https://api.mapbox.com/styles/v1/mapbox/streets-v11/static/"+marker+"("+coordenadas+")/"+coordenadas+","+zoom+",0,0/1080x200@2x?access_token="+this.accessToken
        // console.log("https://api.mapbox.com/styles/v1/mapbox/streets-v11/static/"+this.longitud+","+this.latitud+",14/800x300?access_token="+this.accessToken)
        // return imageMap;
    },
    zoomUpdate(zoom) {
        this.currentZoom = zoom;
    },
    centerUpdate(center) {
        this.currentCenter = center;
    },
  },
  computed: {
    heightMap() {
        switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'height: 250px;'
        case 'sm': return 'height: 300px;'
        case 'md': return 'height: 350px;'
        case 'lg': return 'height: 350px;'
        case 'xl': return 'height: 400px;'
        }
    }
  }
};
</script>

<style scoped>

</style>